import React, { Component } from "react";
import ReactCardCarousel from "react-card-carousel";
import { SparklesIcon } from "@heroicons/react/solid";
import Flipr from "../assets/Certificates/flipr.jpg";
import Hack from "../assets/Certificates/hackolift.jpg";
import Hack4 from "../assets/Certificates/hack4.jpg";
import Fade from "react-reveal/Fade";

class Awards extends Component {
  static get CARD_STYLE() {
    return {
      textAlign: "center",
      background: "#404040",
      color: "#FFF",
      fontFamily: "Source Serif Pro, serif",
      fontWeight: "bold",
      letterSpacing: "0.05rem",
      fontSize: "15px",
      borderRadius: "10px",
      boxSizing: "border-box",
      disable_keydown: "true",
    };
  }

  render() {
    return (
      <section className="px-10">
        {" "}
        <Fade bottom>
          <div>
            <ReactCardCarousel autoplay={true} autoplay_speed={5000}>
              <div className="h-80">
                <img className="My__Cert" alt="MLSA" src={Hack4} />
              </div>
              <div className="h-80">
                <img className="My__Cert" alt="MLSA" src={Flipr} />
              </div>
              <div className="h-80">
                <img className="My__Cert" alt="MLSA" src={Hack} />
              </div>
            </ReactCardCarousel>
          </div>
        </Fade>
      </section>
    );
  }
}
// const Awards = () => {
//   return (
//     <section>
//       <div className="container px-5 py-10 mx-auto text-center lg:px-40">
//         <div className="flex flex-col w-full mb-2">
//           <SparklesIcon className="mx-auto inline-block w-10 mb-4" />
//           <h1 className="z-50 sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
//             Awards{" "}
//           </h1>
//         </div>
//       </div>
//     </section>
//   );
// };

export default Awards;
